export default __webpack_public_path__ + "static/media/111.791c0057.jpeg";